import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertController, NavParams, PopoverController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import Quill from 'quill';
 
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SelectOption } from 'src/app/components/forms/select/select.component';
import { EmailGroup } from 'src/app/models/EmailGroup';
import { ExerciseWod } from 'src/app/models/ExerciseWod';
import { GymBranch } from 'src/app/models/GymBranch';
import { Pagination } from 'src/app/models/Pagination';
import { Round } from 'src/app/models/Round';
import { Routine } from 'src/app/models/Routine';
import { User } from 'src/app/models/User';
import { EmailGroupsProvider } from 'src/app/providers/EmailGroupsProvider';
import { GymBranchProvider } from 'src/app/providers/GymBranchProvider';
import { SmsMessageGroupProvider } from 'src/app/providers/SmsMessageGroupProvider';
import { TemplateProvider } from 'src/app/providers/TemplateProvider';
import { UserProvider } from 'src/app/providers/UserProvider';
import { v4 as uuid } from 'uuid';
import { S3Provider } from 'src/app/providers/S3Provider';
import { WodVideoProvider } from 'src/app/providers/WodVideoProvider';
import { WodProvider } from 'src/app/providers/WodProvider';
import { VideoSelectPage } from '../../routine/video-select/video-select.page';
import {
  pushVideosToEditor,
  buildTooltips,
  pushContentToEditor,
  pushEmojisToEditor
} from 'src/app/classes/QuillHelpers';
import { PopEmojisComponent } from 'src/app/components/pop-emojis/pop-emojis.component';
import { WodSelectPage } from '../../routine/wod-select/wod-select.page';
// import { AddGroupPage } from '../../templates/add-group/add-group.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { MembershipModalComponent } from 'src/app/pages/shop/membership-modal/membership-modal.component';
import { MembershipProvider } from 'src/app/providers/MembershipProvider';
import { TemplateMembershipProvider } from 'src/app/providers/TemplateMembershipProvider';

@Component({
    selector: 'app-user-group-select',
    templateUrl: './user-group-select.page.html',
    styleUrls: ['./user-group-select.page.scss'],
    standalone: false
})
export class UserGroupSelectPage implements OnInit {

  user: User = new User();
  pagInfo: Pagination = new Pagination();
  typeData:number = 1;
  branch:number;
  branches: GymBranch[] = [];
  id_gimnasio:number;
  typeUsersOptions: SelectOption[] = [
    {label:this.translate.instant('GLOBAL.LABELS.ALL'),
    value:1},
    {label:this.translate.instant('GLOBAL.LABELS.LESS_30'),
    value:2},
    {label:this.translate.instant('GLOBAL.LABELS.MORE_30'),
    value:3},
    {label:this.translate.instant('GLOBAL.LABELS.LESS_15'),
    value:4},
    {label:this.translate.instant('GLOBAL.LABELS.LESS_15_W'),
    value:5}
  ]
  tagSelectOptions: SelectOption[] = [];
  // typeUsersOptions: SelectOption[] = [{label:'Todos',value:1},{label:'Menos de 30 dias vencidos',value:2},{label:'Mas de 30 dias vencidos',value:3},{label:'Menos de 15 clases al mes',value:4},{label:'Menos de 15 entrenamientos al mes',value:5}]
  formUsers = new FormGroup<any>({
    searchTerm: new FormControl(''),
    branch: new FormControl(),
    typeUsers: new FormControl(1),
    userType: new FormControl(6),
    tag: new FormControl('0'),
  })
  branchSelectOptions: SelectOption[] = [];
  groups:EmailGroup[] = [];
  groupsSelect:EmailGroup[] = [];
  users: User[] = [];
  usersSelect: User[] = [];
  typeGroup: string;
  onlyAthletes = false;
  idTemplate = 0;
  templateAthletes: User[] = [];
  templateAthletesToDelete = [];
  userIdEditSelected = 0;
  dayEditSelected = null;
  userSelectDays = null;
  daysAdded = [];
  payroll = null;
  usersToDelete = [];

  formularioRoutine = new FormGroup<any>({
    nombre: new FormControl('', Validators.required),
    descripcion: new FormControl(''),
    fecha_de_publicacion: new FormControl(''),
    fecha_entrenamiento: new FormControl(''),
    wod_especificos: new FormControl(false),
    searchG: new FormControl(''),
    search: new FormControl(''),
    branch: new FormControl(),
    crear_grupo: new FormControl(false),
    enviar_notificacion: new FormControl(false),
    nombre_grupo: new FormControl(''),
    tipoEntrenamiento: new FormControl(''),
    tipoResultado: new FormControl(''),
    sectionSelected: new FormControl('')
  });

  routine: Routine = new Routine();
  sectionsList = [];
  editor: any;
  selectOptionRound: SelectOption[] = [];
  rondas: any[] = [];
  selectOptionUnidad: SelectOption[] = [
    {
      label: 'Sin resultado',
      value: 12
    },
    {
      label: 'Libre',
      value: 1
    },
    {
      label: 'Minutos, segundos',
      value: 2
    },
    {
      label: 'Número de repeticiones',
      value: 3
    },
    {
      label: 'Libras',
      value: 4
    },
    {
      label: 'Kilogramos',
      value: 5
    },
    {
      label: 'Metros',
      value: 6
    },
    {
      label: 'Kilometros',
      value: 7
    },
    {
      label: 'Centímetros',
      value: 10
    },
    {
      label: 'Pulgadas',
      value: 11
    },
    {
      label: 'Millas',
      value: 8
    },
    {
      label: 'Calorías',
      value: 9
    }
  ];
  routineRondas: Round[];

  constructor(
    private popoverController: PopoverController,
    private navParams: NavParams,
    private userProvider: UserProvider,
    private emailGroupsProvider:EmailGroupsProvider,
    private toastController: ToastController,
    private branchProvider: GymBranchProvider,
    private storage: Storage,
    private smsMessageGroupProvider: SmsMessageGroupProvider,
    private translate: TranslateService,
    private templateProvider: TemplateProvider,
    private alertController: AlertController,
    private s3Provider: S3Provider,
    private wodVideoProvider: WodVideoProvider,
    private wodProvider: WodProvider,
    private membershipP: MembershipProvider,
    private templateMembershipProvider: TemplateMembershipProvider,
  ) {
    this.formUsers.controls.searchTerm.valueChanges
    .pipe(
      debounceTime(100),
      distinctUntilChanged(),
    ).subscribe( res =>{
      this.getAthletes(1);
    });
   }

  async ngOnInit() {
    this.user = await this.storage.get('user')
    if(this.user.id_rol < 3){
      this.formUsers.controls.userType.setValue(3);
    }

    this.typeData = this.navParams.get('typeView');
    this.branch = this.navParams.get('branch');
    this.id_gimnasio = this.navParams.get('gym');
    this.typeGroup = this.navParams.get('typeGroup');
    this.onlyAthletes = this.navParams.get('onlyAthletes') ? true : false;
    this.idTemplate = this.navParams.get('idTemplate');
    if (this.typeGroup === 'payroll') {
      this.payroll = this.navParams.get('payroll');
      this.formUsers.controls.userType.setValue(4);
      this.payroll.payroll_users.forEach(user => {        
        this.addUser(user);
      });      
    }
    this.getBranches();
    if (this.onlyAthletes) {
      this.getAthletesByTemplate();
      this.getRondas();
      this.getRoutines();
    }
  }
  getAthletes(page:number){
    if(this.typeData == 1)
      this.getUsers(page);
    else
      this.getGroups(page);
  }
  async getBranches(){
    this.branches = await this.branchProvider.bygymSimple(this.user.id_gimnasio);
    this.branchSelectOptions = this.branches.map((b)=>{
      return {
        value: b.id,
        label: b.nombre, 
      }; 
    });
    setTimeout(async () => {
      if(this.user.id_rol == 3)
        this.formUsers.controls.branch.setValue(this.branches[0].id);
      else
        this.formUsers.controls.branch.setValue(this.user.id_sucursal);
      await this.getTags();
      if (!this.payroll) {
        await this.getAthletes(this.pagInfo.currentPage);
      } else {
        await this.getUsers(1);
      }
    }, 100);
  }
  async getUsers(page:number){
    if(this.formUsers.value.userType !=6){
      this.formUsers.controls.typeUsers.setValue(1);
    }
    let data = await this.userProvider.byMessage({
      query: this.formUsers.value.searchTerm,
      id_sucursal: this.formUsers.value.branch,
      id_gimnasio: this.user.id_gimnasio,
      page: page,
      tipo_filtro: this.formUsers.value.typeUsers,
      id_rol: this.formUsers.value.userType,
      idTag: this.formUsers.value.tag
    });
    if (data.data){
      this.users = data.data;
      this.pagInfo.currentPage = data.meta.current_page;
      this.pagInfo.totalPages = data.meta.last_page;
    }
    /* let data = await this.userProvider.getUsersByGym({
      query: this.formUsers.value.searchTerm,
      items: 10,
      id_rol: 6,
      id_sucursal: this.formUsers.value.branch,
      id_gimnasio: this.id_gimnasio,
      page: page,
    });
    if (data.data){
      this.users = data.data;
      this.pagInfo.currentPage = data.meta.current_page;
      this.pagInfo.totalPages = data.meta.last_page;
    } */
  }
  async getGroups(page:number){
    let data = null;
    if(this.typeGroup == 'sms')
      data = await this.smsMessageGroupProvider.getSmsMessageGroups({id_sucursal:this.branch, id_gimnasio:this.id_gimnasio, nombre:this.formUsers.value.searchTerm,page:page });
    else
      data = await this.emailGroupsProvider.getEmailGroups({id_sucursal:this.branch, id_gimnasio:this.id_gimnasio, nombre:this.formUsers.value.searchTerm,page:page });
    if(data.data){
      this.groups = data.data;
      this.pagInfo.currentPage = data.meta.current_page;
      this.pagInfo.totalPages = data.meta.last_page;
    }
  }
  async addUser(athlete:User){
    let usF = this.usersSelect.find(element => element.id == athlete.id);
    if(usF){
      const toast = await this.toastController.create({
        message: this.translate.instant('GLOBAL.LABELS.USER')+" "+this.translate.instant('GLOBAL.LABELS.HAS_ALREADY_BEEN_ASSIGNED_TO_THIS_GROUP'),
        position: 'bottom',
        duration: 3000,
        color: 'danger'
      });
      await toast.present();
    }
    else {
      if (!this.payroll) {
        const params = {
          idUser: athlete.id,
          idTemplate: this.idTemplate
        };
        this.templateProvider.getTemplatesAssignedToUser(params).then(async result => {
          let templateGroups = [];
          if (result.data) {
            result.data.forEach(template => {
              templateGroups.push(template.template.nombre);
            });
            athlete.templateGroups = templateGroups;
          }
          if (templateGroups.length > 0) {
            const alert = await this.alertController.create({
              cssClass: 'alertOden',
              header: 'Advertencia',
              message: 'este atleta se encuentra en los siguientes grupos: ' + templateGroups.join(),
              buttons: [
                {
                  text: 'Cancelar',
                  role: 'cancel',
                  cssClass: 'btn-cancel',
                  handler: () => {
                  }
                }, {
                  text: 'Continuar',
                  cssClass: 'btn-confirm',
                  handler: async (data) => {
                    const toast = await this.toastController.create({
                      message: 'Usuario agregado.',
                      position: 'bottom',
                      duration: 3000,
                      color: 'success'
                    });
                    await toast.present();
                    this.usersSelect.push(athlete);
                  }
                }
              ]
            });
        
            await alert.present();
          } else {
            const toast = await this.toastController.create({
              message: 'Usuario agregado.',
              position: 'bottom',
              duration: 3000,
              color: 'success'
            });
            await toast.present();
            this.usersSelect.push(athlete);
          }
        }, error => {
        });
      } else {
        const toast = await this.toastController.create({
          message: 'Usuario agregado.',
          position: 'bottom',
          duration: 3000,
          color: 'success'
        });
        await toast.present();
        this.usersSelect.push(athlete);
      }
    }
    
  }
  async removeUser(athlete:User){
    let usF = this.usersSelect.find(element => element.id == athlete.id);
    if(usF){
      if (!this.payroll) {
        if (this.existsInList(athlete.id)) {
          this.templateAthletesToDelete.push(athlete.id);
        }
      } else {
        this.usersToDelete.push(athlete.id);
      }
      let index = this.usersSelect.indexOf(athlete);
      this.usersSelect.splice(index,1);
      const toast = await this.toastController.create({
        message: this.translate.instant('GLOBAL.LABELS.USER_DELETED'),
        position: 'bottom',
        duration: 3000,
        color: 'danger'
      });
      await toast.present();
    }
  }

  async addGroup(group:EmailGroup){
    let usF = this.usersSelect.find(element => element.id == group.id);
    if(usF){
      const toast = await this.toastController.create({
        message: this.translate.instant('GLOBAL.LABELS.THIS_GROUP_HAS'),
        position: 'bottom',
        duration: 3000,
        color: 'danger'
      });
      await toast.present();
    }
    else{
      const toast = await this.toastController.create({
        message: this.translate.instant('GLOBAL.LABELS.GROUP_ADDED'),
        position: 'bottom',
        duration: 3000,
        color: 'success'
      });
      await toast.present();
      this.groupsSelect.push(group);
    }
    
  }
  async removeGroup(group:EmailGroup){
    let usF = this.groupsSelect.find(element => element.id == group.id);
    if(usF){
      let index = this.groupsSelect.indexOf(group);
      this.groupsSelect.splice(index,1);
      const toast = await this.toastController.create({
        message: this.translate.instant('GLOBAL.LABELS.THIS_LABEL_IS_REPEATED'),
        position: 'bottom',
        duration: 3000,
        color: 'danger'
      });
      await toast.present();
    }
  }
  addUsersAndBack(){
    let data ={
      users: this.usersSelect,
      groups: this.groupsSelect,
      athletesToDelete: this.templateAthletesToDelete,
      usersToDelete: this.usersToDelete
    };
    this.popoverController.dismiss(data);
  }

  back(){
    this.popoverController.dismiss();
  }
  async getTags(){
    let data = await this.userProvider.getTagsUser(this.formUsers.value.branch,this.user.id_gimnasio,'');
    this.tagSelectOptions.push({'value':-1,'label':'Ninguna'});
    setTimeout(() => {
      this.formUsers.controls.tag.setValue('-1');
    }, 100);
    if(data){

      data.forEach(element => {
        this.tagSelectOptions.push({'value': element.id,'label':element.texto});
      });
    }
  }

  async getAthletesByTemplate() {
    this.templateProvider.getAthletes(this.idTemplate).then((result: any) => {
      if (result.data) {
        result.data.forEach(element => {
          const params = {
            idUser: element.id,
            idTemplate: this.idTemplate
          };
          this.templateProvider.getTemplatesAssignedToUser(params).then(result => {
            if (result.data) {
              let templateGroups = [];
              result.data.forEach(template => {
                templateGroups.push(template.template.nombre);
              });
              element.templateGroups = templateGroups;
            }
            this.templateProvider.getAthleteDetail(
                this.idTemplate,
                element.id
            ).then(result => {
              element.isShop = 0;
              if (result.data) {
                element.isShop = result.data.is_shop;
              }
              this.templateAthletes.push(element);
              this.usersSelect.push(element);
            });
          });
          //this.addUser(element);
        });
        //this.usersSelect = this.templateAthletes;
      }
    }, error => {
    });
  }

  existsInList(athleteId: number) {
    let exists = false;
    this.templateAthletes.forEach(element => {
      if (element.id === athleteId) {
        exists = true;
      }
    });
    return exists;
  }

  editUserTemplate(user) {
    if (this.userSelectDays && this.userSelectDays.id == user.id) {
      this.userSelectDays = null;
    } else {
      this.userSelectDays = user;
    }
  }

  getRoutines() {
    this.daysAdded = [];
    this.templateProvider.getTemplateRoutines(this.idTemplate).then(result => {
      result.data.sort((a,b) => {
        if(parseInt(a.dia) > parseInt(b.dia)) return 1;
        if(parseInt(a.dia) < parseInt(b.dia)) return -1;
        return 0;
      });
      this.daysAdded = result.data;
    }, error => {
    })
  }

  selectDay(day) {
    this.userIdEditSelected = this.userSelectDays.id;
    this.dayEditSelected = day;
    //this.userSelectDays = null;
    this.getCustomRoutine();
    //this.initForm(this.dayEditSelected.coach_personal);
  }

  initForm(routine: Routine) {
    this.routine.id = routine.id;
    this.routine.rondas = [];
    this.routineRondas = routine.rondas;
    this.formularioRoutine.controls.nombre.setValue(routine.nombre);
    this.formularioRoutine.controls.descripcion.setValue(routine.descripcion);
    this.addRoutine(routine);
  }

  addRoutine(routine: Routine) {
    this.routineRondas.forEach((newR, index) => {
      if (index === 0) {
        this.formularioRoutine.controls.tipoResultado.setValue(
          newR.id_tipo_ronda
        );
        this.formularioRoutine.controls.tipoEntrenamiento.setValue(
          newR.id_tipo_wod
        );
      }
      this.addSeccion(newR);
    });
  }

  async addSeccion(newR: Round) {
    if (newR == null) {
      newR = new Round();
    }
    newR.id = uuid();
    this.formularioRoutine.addControl(`names${newR.id}`, new FormControl(newR.nombre)); //[Validators.required]
    this.formularioRoutine.addControl(`tresultado${newR.id}`, new FormControl(parseInt(newR.tipo_de_resultado)));
    this.formularioRoutine.addControl(`tseccion${newR.id}`, new FormControl(newR.id_tipo_ronda));
    this.formularioRoutine.addControl(`secctlimite${newR.id}`, new FormControl(newR.tiempo_limite));
    this.formularioRoutine.addControl(`seccsets${newR.id}`, new FormControl(newR.sets));

    if (newR.ejercicios && newR.ejercicios.length > 0) {
      newR.ejercicios = this.addExerciseCopy(newR)
    }

    this.routine.rondas.push(newR);

    this.formularioRoutine.get(`names${newR.id}`).setValue(
      'Sección ' + (this.sectionsList.length + 1)
    );
    if (newR.nombre === '') {
      newR.nombre = this.formularioRoutine.get(`names${newR.id}`).value;
    }
    

    this.sectionsList.push(
      {
        id: newR.id,
        name: newR.nombre,
        visible: true
      }
    );
    this.sectionsList.forEach(section => {
      if (section.id !== newR.id) {
        section.visible = false;
      }
    });

    this.routine.rondas.forEach(ronda => {
      if (ronda.id !== newR.id) {
        ronda.visible = false;
      }
    });

    this.formularioRoutine.controls.tipoResultado.setValue(parseInt(newR.tipo_de_resultado));
    
    const toast = await this.toastController.create({
      message: 'Sección añadida',
      duration: 1500
    });
    toast.present();
    setTimeout(() => {
      this.buildEditor(newR);
    }, 1000);
  }

  addExerciseCopy(rond: Round) {
    let newR = [];
    rond.ejercicios.forEach(element => {
      let newE = new ExerciseWod();
      newE.id = +uuid();
      newE.id_ejercicio = element.id_ejercicio;
      newE.id_unidad = element.id_unidad;
      newE.intensidad = element.intensidad;
      newE.sets = element.sets;
      newE.tiempo_descanso = element.tiempo_descanso;
      newE.tiempo_limite = element.tiempo_limite;
      newE.tiempo_trabajo = element.tiempo_trabajo;
      newE.repeticiones = element.repeticiones;
      newE.ejercicio = element.ejercicio;
      if (newE.ejercicio) {
        this.formularioRoutine.addControl(`rep${newE.ejercicio.id}`, new FormControl(newE.repeticiones))
        this.formularioRoutine.addControl(`int${newE.ejercicio.id}`, new FormControl(newE.intensidad))
        this.formularioRoutine.addControl(`unidad${newE.ejercicio.id}`, new FormControl(newE.id_unidad))
        this.formularioRoutine.addControl(`sets${newE.ejercicio.id}`, new FormControl(newE.id_unidad))
        this.formularioRoutine.addControl(`ttrabajo${newE.ejercicio.id}`, new FormControl(newE.tiempo_trabajo))
        this.formularioRoutine.addControl(`tdescanso${newE.ejercicio.id}`, new FormControl(newE.tiempo_descanso))
        this.formularioRoutine.addControl(`tlimite${newE.ejercicio.id}`, new FormControl(newE.tiempo_limite))
        newR.push(newE);
      }
    });
    return newR;
  }

  async buildEditor(ronda: Round) {
    let container = document.querySelector(`#editor${ronda.id}`) as HTMLCanvasElement;
    let material_colors = ["#FFEBEE", "#ffcdd2", "#ef9a9a", "#e57373", "#ef5350", "#f44336", "#e53935", "#d32f2f", "#c62828", "#b71c1c", "#ff8a80", "#ff5252", "#ff1744", "#d50000", "#fce4ec", "#f8bbd0", "#f48fb1", "#f06292", "#ec407a", "#e91e63", "#d81b60", "#c2185b", "#ad1457", "#880e4f", "#ff80ab", "#ff4081", "#f50057", "#c51162", "#f3e5f5", "#e1bee7", "#ce93d8", "#ba68c8", "#ab47bc", "#9c27b0", "#8e24aa", "#7b1fa2", "#6a1b9a", "#4a148c", "#ea80fc", "#e040fb", "#d500f9", "#aa00ff", "#ede7f6", "#d1c4e9", "#b39ddb", "#9575cd", "#7e57c2", "#673ab7", "#5e35b1", "#512da8", "#4527a0", "#311b92", "#b388ff", "#7c4dff", "#651fff", "#6200ea", "#e8eaf6", "#c5cae9", "#9fa8da", "#7986cb", "#5c6bc0", "#3f51b5", "#3949ab", "#303f9f", "#283593", "#1a237e", "#8c9eff", "#536dfe", "#3d5afe", "#304ffe", "#e3f2fd", "#bbdefb", "#90caf9", "#64b5f6", "#42a5f5", "#2196f3", "#1e88e5", "#1976d2", "#1565c0", "#0d47a1", "#82b1ff", "#448aff", "#2979ff", "#2962ff", "#e1f5fe", "#b3e5fc", "#81d4fa", "#4fc3f7", "#29b6f6", "#03a9f4", "#039be5", "#0288d1", "#0277bd", "#01579b", "#80d8ff", "#40c4ff", "#00b0ff", "#0091ea", "#e0f7fa", "#b2ebf2", "#80deea", "#4dd0e1", "#26c6da", "#00bcd4", "#00acc1", "#0097a7", "#00838f", "#006064", "#84ffff", "#18ffff", "#00e5ff", "#00b8d4", "#e0f2f1", "#b2dfdb", "#80cbc4", "#4db6ac", "#26a69a", "#009688", "#00897b", "#00796b", "#00695c", "#004d40", "#a7ffeb", "#64ffda", "#1de9b6", "#00bfa5", "#e8f5e9", "#c8e6c9", "#a5d6a7", "#81c784", "#66bb6a", "#4caf50", "#43a047", "#388e3c", "#2e7d32", "#1b5e20", "#b9f6ca", "#69f0ae", "#00e676", "#00c853", "#f1f8e9", "#dcedc8", "#c5e1a5", "#aed581", "#9ccc65", "#8bc34a", "#7cb342", "#689f38", "#558b2f", "#33691e", "#ccff90", "#b2ff59", "#76ff03", "#64dd17", "#f9fbe7", "#f0f4c3", "#e6ee9c", "#dce775", "#d4e157", "#cddc39", "#c0ca33", "#afb42b", "#9e9d24", "#827717", "#f4ff81", "#eeff41", "#c6ff00", "#aeea00", "#fffde7", "#fff9c4", "#fff59d", "#fff176", "#ffee58", "#ffeb3b", "#fdd835", "#fbc02d", "#f9a825", "#f57f17", "#ffff8d", "#ffff00", "#ffea00", "#ffd600", "#fff8e1", "#ffecb3", "#ffe082", "#ffd54f", "#ffca28", "#ffc107", "#ffb300", "#ffa000", "#ff8f00", "#ff6f00", "#ffe57f", "#ffd740", "#ffc400", "#ffab00", "#fff3e0", "#ffe0b2", "#ffcc80", "#ffb74d", "#ffa726", "#ff9800", "#fb8c00", "#f57c00", "#ef6c00", "#e65100", "#ffd180", "#ffab40", "#ff9100", "#ff6d00", "#fbe9e7", "#ffccbc", "#ffab91", "#ff8a65", "#ff7043", "#ff5722", "#f4511e", "#e64a19", "#d84315", "#bf360c", "#ff9e80", "#ff6e40", "#ff3d00", "#dd2c00", "#efebe9", "#d7ccc8", "#bcaaa4", "#a1887f", "#8d6e63", "#795548", "#6d4c41", "#5d4037", "#4e342e", "#3e2723", "#fafafa", "#f5f5f5", "#eeeeee", "#e0e0e0", "#bdbdbd", "#9e9e9e", "#757575", "#616161", "#424242", "#212121", "#eceff1", "#cfd8dc", "#b0bec5", "#90a4ae", "#78909c", "#607d8b", "#546e7a", "#455a64", "#37474f", "#263238", "#000000", "#ffffff", "#A5ECDD"];

    var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike', 'video', { 'header': [1, 2, 3, 4, 5, 6, false] }],        // toggled buttons
    ];

    var Videos = function(quill, options) {
      this.quill = quill;
      this.options = options;
      var _this = this;
      quill.on('text-change', async function() {
        let text = quill.getText();
        const words = text.split(' ');
        const search = words[words.length - 1];
        if (search.length > 3) {
          options.handlers.delta(search, quill)
        }
      });
    };

    Quill.register('modules/videos', Videos);

    var options = {
      theme: 'snow',
      modules: {
        toolbar: {
          container: toolbarOptions,
          handlers: {
            image: (e) => {
              this.selectLocalImage(ronda.editor);
            }
          }
        },
        videos: {
          container: '#counter',
          handlers: {
            delta: (e) => {
              this.getVideos(e, null);
            }
          }
        },
      },
      placeholder: 'Escribe aquí...'
    }
    ronda.editor = new Quill(container, options);    
    if (ronda.content == "[]" || ronda.content != null && ronda.content != undefined && ronda.content != "") {
      let contenido: any = ronda.content.ops;

      if (typeof contenido !== 'undefined') {
        // pushContentToEditor(ronda.editor, contenido);

        setTimeout(() => {
          ronda.editor.setContents(contenido);
        }, 100);
      } else {

        setTimeout(() => {
          ronda.editor.setContents(JSON.parse(ronda.content));
        }, 100);
      }
    }
    ronda.visible = true;

    this.editor = ronda.editor;
    
  }

  public selectLocalImage(editor) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.click();
    input.onchange = ($e) => {
      const file = input.files[0];
      if (file.type.includes("image")) {
        const range = editor.getSelection();
        this.s3Provider.upload(file).then((url) => {
          editor.insertEmbed(range.index, 'image', url);
        });
      } else {
        console.warn('You could only upload images.');
      }
    };
  }

  async getVideos(search, quill) {
    //this.spinner.show();
    const data = {
      page: 1,
      gymId: this.user.id_gimnasio,
      filter: search
    };
    let theVideo = null;
    this.wodVideoProvider.getVideos(data).then(result => {
      let response: any = result;
      //this.spinner.hide();
      if (response.data.length > 0) {
        theVideo = response.data[0];
      }
    }, error => {
      //this.spinner.hide();
    });
    return theVideo;
  }

  async getRondas() {
    let data = await this.wodProvider.getTipWods();
    if (data.data) {
      this.rondas = data.data;
      this.rondas.forEach(element => {
        this.selectOptionRound.push({ label: element.nombre, value: element.id });
      });
    }
  }

  backToAssignAthletes() {
    this.userIdEditSelected = 0;
    this.dayEditSelected = null;
    this.userSelectDays = null;
    this.routine = new Routine();
    this.formularioRoutine.reset();
  }

  async addVideo(rond: Round) {
    let i=rond.editor.getSelection(true)
    const popover = await this.popoverController.create({
      component: VideoSelectPage,
      cssClass: 'popoverVideoLibrary',
      translucent: true
    });
    await popover.present();

    popover.onDidDismiss().then(data => {
      if (data.data && data.data.length > 0) {
        pushVideosToEditor(rond.editor, data.data,i);
      }
    });
  }

  async openEmojisPop(ronda){
    let i = ronda.editor.getSelection(true)
    const popover = await this.popoverController.create({
      component: PopEmojisComponent,
      cssClass: 'popEmojis',
      translucent: true
    });
    await popover.present();
    popover.onDidDismiss()
    .then((data) => {
      pushEmojisToEditor(ronda.editor, data.data, i);
    });
  }

  async copySeccion(rond: Round) {

    this.buildRoutine();
    let newR = new Round();
    newR.id = uuid();
    newR.id_tipo_ronda = rond.id_tipo_ronda;
    newR.id_tipo_wod = rond.id_tipo_wod;
    newR.nombre = rond.nombre + ' copia';
    newR.sets = rond.sets;
    newR.tiempo_limite = rond.tiempo_limite;
    newR.tipo_de_resultado = rond.tipo_de_resultado;
    newR.content = JSON.stringify(rond.content);
    newR.descanso = null;
    newR.ejercicios = this.addExerciseCopy(rond);

    let index = this.routine.rondas.indexOf(rond);
    this.formularioRoutine.addControl(`names${newR.id}`, new FormControl(rond.nombre));//[Validators.required]
    this.formularioRoutine.addControl(`tresultado${newR.id}`, new FormControl(parseInt(rond.tipo_de_resultado)));
    this.formularioRoutine.addControl(`tseccion${newR.id}`, new FormControl(rond.id_tipo_ronda));
    this.formularioRoutine.addControl(`secctlimite${newR.id}`, new FormControl(rond.tiempo_limite));
    this.formularioRoutine.addControl(`seccsets${newR.id}`, new FormControl(rond.sets));

    this.routine.rondas.splice(index + 1, 0, newR);
    setTimeout(() => {
      this.buildEditor(newR);
    }, 1000);
    this.formularioRoutine.get(`names${newR.id}`).setValue(rond.nombre + ' ' + 'copia');
    const toast = await this.toastController.create({
      message: 'Copia realizada y pegada',
      duration: 1500
    });
    toast.present();

  }

  async buildRoutine() {
    this.routine.nombre = this.formularioRoutine.value.nombre;
    this.routine.descripcion = this.formularioRoutine.value.descripcion;
    this.routine.id_usuario = this.user.id;
    this.routine.tz = this.getTimeZoneClient();
    let orderRond = 1;
    this.routine.rondas.forEach((element,i) => {
      element.nombre = this.formularioRoutine.get(`names${element.id}`).value==''?'Sección '+(i+1):this.formularioRoutine.get(`names${element.id}`).value;
      element.id_tipo_ronda = this.formularioRoutine.get(`tseccion${element.id}`).value;
      element.id_tipo_wod = this.formularioRoutine.get(`tseccion${element.id}`).value;
      element.notas = '';
      element.tipo_de_resultado = this.formularioRoutine.get(`tresultado${element.id}`).value; // estaba= 1
      element.content = element.editor.getContents();
      element.descanso = '';
      element.id_order = orderRond;
      orderRond++;
      switch (element.id_tipo_ronda) {
        case 1: // por tiempo
          element.tiempo_limite = this.formularioRoutine.get(`secctlimite${element.id}`).value;
          element.sets = this.formularioRoutine.get(`seccsets${element.id}`).value;
          break;
        case 2: //fuerza
          element.tiempo_limite = null
          element.sets = null;
          break;
        case 3: //distancia
          element.tiempo_limite = null;
          element.sets = null;
          break;
        case 4: //calidad
          element.tiempo_limite = null;
          element.sets = null;
          break;
        case 5: //amrap
          element.tiempo_limite = null;
          element.sets = this.formularioRoutine.get(`seccsets${element.id}`).value;
          break;
        case 6: // intervalos
          element.tiempo_limite = this.formularioRoutine.get(`secctlimite${element.id}`).value;
          element.sets = null;
          break;
        case 7:
          element.tiempo_limite = null;
          element.sets = null;
          break;
      }
      element.ejercicios.forEach(elementE => {
        elementE = this.buildEjercicio(elementE, element.id_tipo_ronda);
        elementE.id_ejercicio = elementE.ejercicio.id;
      });
    });
  }

  getTimeZoneClient() {
    let f = new Date();
    var resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
    return resolvedOptions.timeZone
  }

  buildEjercicio(ej: ExerciseWod, id_tipo_ronda) {

    let exerc = ej;
    switch (id_tipo_ronda) {
      case 1: // por tiempo
        exerc.repeticiones = parseInt(this.formularioRoutine.get(`rep${exerc.ejercicio.id}`).value);
        exerc.intensidad = this.formularioRoutine.get(`int${exerc.ejercicio.id}`).value;
        exerc.id_unidad = this.formularioRoutine.get(`unidad${exerc.ejercicio.id}`).value;
        break;
      case 2:
        exerc.sets = parseInt(this.formularioRoutine.get(`sets${exerc.ejercicio.id}`).value);
        exerc.repeticiones = parseInt(this.formularioRoutine.get(`rep${exerc.ejercicio.id}`).value);
        exerc.intensidad = this.formularioRoutine.get(`int${exerc.ejercicio.id}`).value;
        exerc.id_unidad = this.formularioRoutine.get(`unidad${exerc.ejercicio.id}`).value;

        break;
      case 3:
        exerc.repeticiones = parseInt(this.formularioRoutine.get(`rep${exerc.ejercicio.id}`).value);
        exerc.intensidad = this.formularioRoutine.get(`int${exerc.ejercicio.id}`).value;
        exerc.tiempo_limite = parseInt(this.formularioRoutine.get(`tlimite${exerc.ejercicio.id}`).value);
        exerc.id_unidad = this.formularioRoutine.get(`unidad${exerc.ejercicio.id}`).value;

        break;
      case 4:
        exerc.repeticiones = parseInt(this.formularioRoutine.get(`rep${exerc.ejercicio.id}`).value);
        exerc.sets = parseInt(this.formularioRoutine.get(`sets${exerc.ejercicio.id}`).value);
        break;
      case 5:
        exerc.intensidad = this.formularioRoutine.get(`int${exerc.ejercicio.id}`).value;
        exerc.id_unidad = this.formularioRoutine.get(`unidad${exerc.ejercicio.id}`).value;
        exerc.tiempo_trabajo = parseInt(this.formularioRoutine.get(`ttrabajo${exerc.ejercicio.id}`).value);
        exerc.tiempo_descanso = parseInt(this.formularioRoutine.get(`tdescanso${exerc.ejercicio.id}`).value);
        break;
      case 6:
        exerc.repeticiones = parseInt(this.formularioRoutine.get(`rep${exerc.ejercicio.id}`).value);
        exerc.intensidad = this.formularioRoutine.get(`int${exerc.ejercicio.id}`).value;
        exerc.id_unidad = this.formularioRoutine.get(`unidad${exerc.ejercicio.id}`).value;
        break;
      case 7:

        break;
    }
    return exerc;
  }

  upSection(rond: Round) {
    let index = this.routine.rondas.indexOf(rond);
    let rondMov = this.routine.rondas[index - 1];
    this.routine.rondas[index - 1] = rond;
    this.routine.rondas[index] = rondMov;
  }

  downSection(rond: Round) {
    let index = this.routine.rondas.indexOf(rond);
    let rondMov = this.routine.rondas[index + 1];
    this.routine.rondas[index + 1] = rond;
    this.routine.rondas[index] = rondMov;
  }

  async removeSeccion(secc: Round) {
    this.routine.rondas.forEach((ronda, index) => {
      if (ronda.id === secc.id) {
        this.routine.rondas.splice(index, 1);
      }
    });
    this.routine.rondas.forEach((ronda, index) => {
      ronda.nombre = ronda.nombre
        ? ronda.nombre
        : 'seccion ' + (index + 1);
    });
    this.formularioRoutine.removeControl(`names${secc.id}`);
    this.formularioRoutine.removeControl(`tresultado${secc.id}`);
    this.formularioRoutine.removeControl(`tseccion${secc.id}`);
    this.sectionsList.forEach((section, index) => {
      if (section.id === secc.id) {
        this.sectionsList.splice(index, 1);
      }
    });
    this.sectionsList.forEach((section, index) => {
        section.name = section.name
          ? section.name
          : 'seccion ' + (index + 1);
    });
    const toast = await this.toastController.create({
      message: 'Sección removida',
      duration: 1500
    });
    toast.present();
  }

  async addWodLibrary() {
    const popover = await this.popoverController.create({
      component: WodSelectPage,
      componentProps: {
        type: 'coach'
      },
      cssClass: 'popoverWodLibrary',
      translucent: true
    });
    await popover.present();

    popover.onDidDismiss().then(data => {
      
      if (data.data) {
        let contentLength = this.editor.getLength();
        let isEmpty = true;
        if (contentLength > 1) {
          isEmpty = false;
        }

        data.data.forEach((element, index) => {
          if (index == 0 && isEmpty) {
            this.formularioRoutine.get(`names${this.routine.rondas[0].id}`).setValue(
              element.nombre
            );
            this.sectionsList.forEach(element => {
              if (element.id === this.routine.rondas[0].id) {
                element.name = this.formularioRoutine.get(`names${this.routine.rondas[0].id}`).value;
                this.routine.rondas[index].nombre = element.name;
              }
            });
            const contenido = JSON.parse(data.data[0].content);
            this.editor.setContents(contenido.ops);
          } else {
            this.addSeccion(element);
          }
        });
      }
    });
  }

  async updateRoutine() {
    await this.buildRoutine();
    const params = {
      wod: this.routine,
      templateId: this.idTemplate,
      user: this.user,
      atletas: [this.userSelectDays],
      grupos: [],
      gruposCoach: [],
      daySelected: this.dayEditSelected
    }
    this.templateProvider.saveCustomWod(params).then( async result => {
      if (result.data) {
        const toast = await this.toastController.create({
          message: 'El entrenamiento se ha actualizado correctamente',
          duration: 1500,
          color: 'success'
        });
        toast.present();
        this.backToAssignAthletes();
      } else {
        const toast = await this.toastController.create({
          message: 'Ocurrio un error al actualizar el entrenamiento personalizado',
          duration: 1500,
          color: 'success'
        });
        toast.present();
      }
    }, error => {
    });
  }

  getCustomRoutine() {
    const params = {
      id_template: this.idTemplate,
      dia: this.dayEditSelected.dia,
      id_usuario: this.userSelectDays.id
    };
    this.templateProvider.getCustomRoutine(params).then(result => {
      if (result.data) {
        this.initForm(result.data);
      } else {
        this.initForm(this.dayEditSelected.coach_personal);
      }
    }, error => {
    });
  }

  // async editInitialRoutineUser(user: User) {
  //   this.templateProvider.getTemplateInfo(this.idTemplate).then(async result => {
  //     const popover = await this.popoverController.create({
  //       component: AddGroupPage,
  //       componentProps: {
  //         template: result.data,
  //         data: user,
  //         type: 'user'
  //       },
  //       cssClass: 'popoverAddGroup',
  //       translucent: true
  //     });
  //     await popover.present();
  //     popover.onDidDismiss().then(async data => {
  //       if (data.data) {
  //         if (data.data) {
  //           const toast = await this.toastController.create({
  //             message: 'La asignación ha sido realizada correctamente',
  //             duration: 1500,
  //             color: 'success'
  //           });
  //           toast.present();
  //         }
  //         //this.getTemplates();
  //       }
  //     });
  //   }, error => {
  //   });
  // }

  async openMembershipDetails(user: User) {
    let membresia;
    if (this.user.gimnasio.type !== 'coach') {
      membresia = await this.membershipP.showMembershipNoSessions(1);
    } else {
      membresia = await this.templateMembershipProvider.getUserMembership(user.id);
    }
    if (membresia) {
      let modal= await this.popoverController.create({
        component: MembershipModalComponent,  
        backdropDismiss:true,
        translucent:false,
        cssClass:'popoverMemberships',     
        componentProps:{
          membresia: membresia
        } 
      });
      modal.present()
    }
  }

}
